import React from 'react';
import styled from 'styled-components';

import Loader from '../loader';
import media from '../../utils/mediaQueries';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 300px;
  align-items: center;
  justify-content: center;
  
  ${media.mobile`
    height: 188px;
  `}
`;

const LoadingScreen = () => (
  <Container>
    <Loader />
    <div>Un instant, s’il vous plaît…</div>
  </Container>
);

export { LoadingScreen };
